import { api } from '../../api/client'
import {
  AwsSsoConnectionWizard,
  type AwsSsoConnectionApi,
  type AwsSsoResolvedAccount,
} from './AwsSsoConnectionWizard'

export interface SsoResolvedAccount {
  aws_account_id: string
  name: string
  access_key: string
  secret_key: string
  session_key: string
}

export function AwsSsoWizard({
  onAccountsResolved,
  autoOpenSignal = 0,
  hideTrigger = false,
  ssoApi,
}: {
  onAccountsResolved: (accounts: SsoResolvedAccount[]) => void
  autoOpenSignal?: number
  hideTrigger?: boolean
  /** Override the device-flow endpoints (the public /newcustomer flow routes
   *  them through its token-gated proxy). Defaults to the signed-in API. */
  ssoApi?: AwsSsoConnectionApi | undefined
}) {
  const handleResolved = (accounts: AwsSsoResolvedAccount[]) => {
    onAccountsResolved(
      accounts.map(({ account, credentials }) => ({
        aws_account_id: account.account_id,
        name: account.account_name,
        access_key: credentials.access_key_id,
        secret_key: credentials.secret_access_key,
        session_key: credentials.session_token,
      })),
    )
  }

  return (
    <AwsSsoConnectionWizard
      api={
        ssoApi ?? {
          start: api.ssoStart,
          token: api.ssoToken,
          accounts: api.ssoAccounts,
          credentials: api.ssoCredentials,
          provisionAccessKeys: api.ssoProvisionAccessKeys,
        }
      }
      onResolvedAccounts={handleResolved}
      buttonTitle="Sign in with AWS IAM Identity Center for temporary or optional long-term scan access"
      autoOpenSignal={autoOpenSignal}
      hideTrigger={hideTrigger}
    />
  )
}
